/*
We're constantly improving the code you see.
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from 'react'

export const UnitIcon = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
    >
      <path
        d="M14.0597 9.53591H11.0532C9.55739 9.53591 8.83553 8.84381 8.83553 7.41498V2.35451C8.83553 0.925675 9.56483 0.233582 11.0532 0.233582H14.0597C15.5555 0.233582 16.2774 0.925675 16.2774 2.35451V7.41498C16.2774 8.84381 15.5481 9.53591 14.0597 9.53591ZM11.0532 1.34986C10.1081 1.34986 9.95181 1.60288 9.95181 2.35451V7.41498C9.95181 8.1666 10.1081 8.41963 11.0532 8.41963H14.0597C15.0048 8.41963 15.1611 8.1666 15.1611 7.41498V2.35451C15.1611 1.60288 15.0048 1.34986 14.0597 1.34986H11.0532Z"
        fill="#7E92A2"
      />
      <path
        d="M14.0597 15.7335H11.0532C10.3729 15.7335 9.96711 15.5753 9.72913 15.3476C9.49548 15.124 9.33553 14.7485 9.33553 14.1126V12.773C9.33553 12.1384 9.49665 11.7626 9.73146 11.5384C9.9708 11.31 10.3772 11.1521 11.0532 11.1521H14.0597C14.74 11.1521 15.1458 11.3103 15.3838 11.538C15.6174 11.7616 15.7774 12.137 15.7774 12.773V14.1126C15.7774 14.7472 15.6163 15.123 15.3815 15.3472C15.1421 15.5756 14.7357 15.7335 14.0597 15.7335ZM11.0532 11.2684C10.5821 11.2684 10.1101 11.3197 9.79453 11.6353C9.47523 11.9546 9.45181 12.411 9.45181 12.773V14.1126C9.45181 14.4746 9.47523 14.931 9.79453 15.2503C10.1101 15.5659 10.5821 15.6172 11.0532 15.6172H14.0597C14.5308 15.6172 15.0028 15.5659 15.3184 15.2503C15.6377 14.931 15.6611 14.4746 15.6611 14.1126V12.773C15.6611 12.411 15.6377 11.9546 15.3184 11.6353C15.0028 11.3197 14.5308 11.2684 14.0597 11.2684H11.0532Z"
        stroke="#7E92A2"
      />
      <path
        d="M5.50158 16.2336H2.49507C0.99925 16.2336 0.27739 15.5415 0.27739 14.1127V9.05219C0.27739 7.62335 1.00669 6.93126 2.49507 6.93126H5.50158C6.99739 6.93126 7.71925 7.62335 7.71925 9.05219V14.1127C7.71925 15.5415 6.98995 16.2336 5.50158 16.2336ZM2.49507 8.04754C1.54995 8.04754 1.39367 8.30056 1.39367 9.05219V14.1127C1.39367 14.8643 1.54995 15.1173 2.49507 15.1173H5.50158C6.4467 15.1173 6.60297 14.8643 6.60297 14.1127V9.05219C6.60297 8.30056 6.4467 8.04754 5.50158 8.04754H2.49507Z"
        fill="#7E92A2"
      />
      <path
        d="M5.50158 5.81498H2.49507C0.99925 5.81498 0.27739 5.12288 0.27739 3.69405V2.35451C0.27739 0.925674 1.00669 0.233582 2.49507 0.233582H5.50158C6.99739 0.233582 7.71925 0.925674 7.71925 2.35451V3.69405C7.71925 5.12288 6.98995 5.81498 5.50158 5.81498ZM2.49507 1.34986C1.54995 1.34986 1.39367 1.60288 1.39367 2.35451V3.69405C1.39367 4.44567 1.54995 4.6987 2.49507 4.6987H5.50158C6.4467 4.6987 6.60297 4.44567 6.60297 3.69405V2.35451C6.60297 1.60288 6.4467 1.34986 5.50158 1.34986H2.49507Z"
        fill="#7E92A2"
      />
    </svg>
  )
}
